var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.228 7.114H7.995a.91.91 0 0 0-.896.91v8.232a.91.91 0 0 0 .91.91h8.232a.91.91 0 0 0 .905-.91V8.023a.91.91 0 0 0-.91-.91h-.008Zm-6.034 8.689a.271.271 0 0 1-.271.271H8.804a.272.272 0 0 1-.271-.271v-4.73a.272.272 0 0 1 .271-.272h1.127a.272.272 0 0 1 .272.272v4.722l-.009.008Zm-.828-5.43a1.07 1.07 0 1 1 .033-2.14 1.07 1.07 0 0 1-.033 2.14Zm6.715 5.452a.242.242 0 0 1-.241.244H14.63a.246.246 0 0 1-.244-.244v-2.213c0-.332.098-1.448-.864-1.448-.744 0-.896.763-.925 1.108v2.553a.246.246 0 0 1-.151.226.246.246 0 0 1-.094.018h-1.168a.244.244 0 0 1-.244-.244V11.05a.244.244 0 0 1 .244-.244h1.168a.244.244 0 0 1 .245.244v.413c.271-.416.686-.736 1.56-.736 1.934 0 1.923 1.808 1.923 2.802V15.824Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.111 23.474a11.333 11.333 0 1 1 3.492-22.119.38.38 0 0 1-.233.725 10.568 10.568 0 1 0 6.072 5.086.383.383 0 0 1 .673-.361 11.34 11.34 0 0 1-10.004 16.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.788 4.709a.375.375 0 0 1-.272-.109 10.76 10.76 0 0 0-1.564-1.268.383.383 0 0 1 .423-.636c.272.174.514.359.758.544.32.255.626.527.918.814a.377.377 0 0 1 0 .543.375.375 0 0 1-.263.112Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.777 .806)",
    d: "M0 0h22.668v22.668H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.63a9862e7bcbfa8d5d9bfd9554412688.svg";
export { ForwardRef as ReactComponent };